import { msg } from '@lingui/core/macro';

import type { LearningFilterKey } from './types';

export const DEFAULT_TAB_KEY = 'all';

export const LEARNING_FILTER_KEYS = {
    Rank: 'rank',
    LearningState: 'learningState',
} as const;

export const LEARNING_DROPDOWN_FILTER_KEYS = (Object.values(LEARNING_FILTER_KEYS) as LearningFilterKey[]).filter(
    (key) => key !== LEARNING_FILTER_KEYS.LearningState,
);

export const SHARED_LEARNING_SECTIONS_LEARNING_LIBRARY_LABEL = msg`Learning library`;
export const SHARED_LEARNING_SECTIONS_HEADING = msg`Career roadmap`;
export const SHARED_LEARNING_SECTIONS_CAREER_ROADMAP_SUBHEADER = msg`Prepare for your next rank with these pathways.`;
export const SHARED_LEARNING_SECTIONS_CAREER_ROADMAP_TOOLTIP_TEXT = msg`Additional Pathways that prepare you for your next rank.`;
